export const getSuccessFeedbackConfig = ({ targetType, }) => {
    const capitalizedTarget = targetType.toUpperCase();
    return {
        message: `SHARE_FEEDBACK_${capitalizedTarget}_MESSAGE`,
        button: `SHARE_FEEDBACK_${capitalizedTarget}_BUTTON`,
    };
};
//# sourceMappingURL=get-success-feedback-config.js.map